import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import sounds from 'src/lib/sounds';
import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import { Avatar } from '../components/shared/Avatar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { energyGiftConfirmation as ui } from './PopupGiftsConfirmation.style';

export default class PopupGiftsConfirmation extends PopupBasic<
  (canceled: boolean) => void
> {
  private avatar: Avatar;
  private playerName: LangBitmapFontTextView;

  constructor(opts: { superview: View; close: (canceled: boolean) => void }) {
    super({
      superview: opts.superview,
      close: () => opts.close(true),
      zIndex: 10000,
      width: uiConfig.popups.buruburu.width,
      height: 525,
      darkerBg: false,
      tracking: { feature: 'profile', $subFeature: 'popup-energyGift' },
      titleIcon: {
        image: 'assets/ui/gifts/icons/gifts_popup_icon.png',
      },
    });

    this.buttonClose.removeFromSuperview();

    // Top Separator
    new View({
      superview: this.box,
      ...ui.separator,
      x: this.box.style.width / 2,
    });

    this.message.updateOpts({
      superview: this.box,
      ...ui.message,
      x: this.box.style.width / 2,
    });

    const frame = new ImageScaleView({
      superview: this.box,
      ...ui.frame,
      width: this.box.style.width * 0.9,
      x: this.box.style.width / 2,
    });

    this.avatar = new Avatar({
      superview: frame,
      x: 85,
      y: frame.style.height * 0.5,
      width: 115,
      height: 115,
    });

    this.playerName = new LangBitmapFontTextView({
      superview: frame,
      ...ui.playerName,
      height: frame.style.height,
    });

    new LangBitmapFontTextView({
      superview: this.box,
      ...ui.warning,
      x: this.box.style.width / 2,
      localeText: () => i18n('gifts.popupConfirmation.warning'),
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.cancel,
      ...ui.button,
      superview: this.box,
      x: this.box.style.width / 4,
      y: this.box.style.height - 25 - 100 / 2,
      localeText: () => i18n('basic.cancel'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        return opts.close(false);
      },
      tracking: { feature: 'profile', $subFeature: 'popup-energyGift-close' },
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      ...ui.button,
      x: (this.box.style.width / 4) * 3,
      y: this.box.style.height - 25 - 100 / 2,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(true);
      },
      tracking: { feature: 'profile', $subFeature: 'popup-energyGift-ok' },
    });
  }

  public init({ avatar, playerName }: { avatar: string; playerName: string }) {
    super.init({
      title: i18n('gifts.popupConfirmation.title'),
      message: i18n('gifts.popupConfirmation.message'),
    });

    this.playerName.localeText = () => playerName ?? 'John Doe';
    this.avatar.updateImage(avatar);
  }
}
